export const FETCH_IH_TRANSFERS_REQUEST = 'FETCH_IH_TRANSFERS_REQUEST';
export const FETCH_IH_TRANSFERS_SUCCESS = 'FETCH_IH_TRANSFERS_SUCCESS';
export const FETCH_IH_TRANSFERS_FAILURE = 'FETCH_IH_TRANSFERS_FAILURE';
export const REFRESH_IH_TRANSFERS = 'REFRESH_IH_TRANSFERS';